import { render, staticRenderFns } from "./HeaderComponent.vue?vue&type=template&id=b0999720"
import script from "./HeaderComponent.vue?vue&type=script&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&lang=js"
import style0 from "./HeaderComponent.vue?vue&type=style&index=0&id=b0999720&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports